export const inviteFriendErrorInformation: { [id: string]: string } = {
  userAlreadyExist: "User already exists",
};
